import { Text, View } from "@react-pdf/renderer";

import { Attribution } from "~/common/components";
import { ConsultationExportReportExams } from "~/providers/components/pdf/ConsultationExport/ConsultationExportReportExams";
import { PdfPatientInformationCard } from "~/providers/components/pdf/shared";
import { getPdfPatientInformationFromConsultation } from "~/providers/components/pdf/utils";
import { ConsultationExport } from "~/providers/utils/types/consultation";
import { styles } from "../styles";

export const ConsultationExportReport = ({
  data,
}: {
  data: ConsultationExport;
}) => {
  const { report } = data;
  const teamMember = report.completed_by?.team_member;
  const patientInformation = getPdfPatientInformationFromConsultation(data);

  return (
    <>
      <View style={[styles.section, styles.tight]}>
        <Text style={[styles.h1, { color: "#2433A8", marginBottom: 4 }]}>
          Consultation report (H&P)
        </Text>
        <Text>
          <Attribution
            firstName={teamMember?.name}
            lastName={teamMember?.last_name}
            date={report.completed_at}
          />
        </Text>
      </View>

      <PdfPatientInformationCard {...patientInformation} />

      <View style={[styles.section]} wrap={false}>
        <Text style={[styles.h2]}>Chief complaint</Text>
        <Text>{report.chief_complaint}</Text>
      </View>

      <View style={[styles.section]} wrap={false}>
        <Text style={[styles.h2]}>History of present illness</Text>
        <Text>{report.history_of_present_illness}</Text>
      </View>

      <View
        style={[styles.section, { flexDirection: "column", rowGap: 8 }]}
        wrap={false}
      >
        <Text style={[styles.h2, { marginBottom: 0 }]}>
          Past health history
        </Text>
        <Text style={[styles.h3, { marginBottom: 0 }]}>
          Psychiatric history
        </Text>
        <Text>{report.past_psychiatric_history}</Text>
        <Text style={[styles.h3, { marginBottom: 0 }]}>Medical history</Text>
        <Text>{report.past_medical_history}</Text>
      </View>

      <View style={[styles.section]} wrap={false}>
        <Text style={[styles.h2]}>Medications</Text>
        <Text style={styles.upperfirst}>{report.medications}</Text>
      </View>

      <View style={[styles.section]} wrap={false}>
        <Text style={[styles.h2]}>Substance history</Text>
        <Text style={styles.upperfirst}>{report.substances}</Text>
      </View>

      <View style={[styles.section]} wrap={false}>
        <Text style={[styles.h2]}>Allergies</Text>
        <Text style={styles.upperfirst}>{report.allergies}</Text>
      </View>

      <View style={[styles.section]}>
        <Text style={[styles.h2]}>Past personal history</Text>
        <Text style={styles.upperfirst}>{report.past_personal_history}</Text>
      </View>

      <View style={[styles.section]}>
        <Text style={[styles.h2]}>Educational history</Text>
        <Text style={styles.upperfirst}>{report.education_history}</Text>
      </View>

      <View style={[styles.section]}>
        <Text style={[styles.h2]}>Family history</Text>
        <Text style={styles.upperfirst}>{report.family_history}</Text>
      </View>

      <View style={[styles.section]}>
        <Text style={[styles.h2]}>Psychiatric review of symptoms</Text>
        <Text>{report.psychiatric_review.replace(/^\s*-\s/gm, "• ")}</Text>
      </View>

      <View style={[styles.section]}>
        <Text style={[styles.h2]}>Mental status examination</Text>

        <ConsultationExportReportExams
          exam={report.mental_status_examination}
        />
      </View>

      <View style={[styles.section]}>
        <Text style={[styles.h2]}>Assessment</Text>
        <Text>{report.assessment}</Text>
      </View>

      <View style={[styles.section, styles.tight]}>
        <Text style={[styles.h2]}>Plan of care</Text>
        <Text>{report.plan_of_care}</Text>
      </View>
    </>
  );
};
